import React from "react";
import ReactDOM from "react-dom/client";
import "fonts/satoshi.css";
import "globals.scss";
import "main.scss";
import {Application} from "Application";
import {disableMobileZoom} from "utils/disableMobileZoom";
import {applyABOverridesFromUrl} from "utils/abTest";

disableMobileZoom();
applyABOverridesFromUrl();

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);

root.render(<Application/>);
